import "../../styles/components/ProfileCompletionBar.css";

const ProfileCompletionBar = ({
  status,
}) => {
  const profile =
    status?.profile || {
      percentage: 0,
      completed: 0,
      total: 4,
      remaining: 4,
    };

  const verification =
    status?.verification || {
      percentage: 0,
      verified: 0,
      pending: 0,
      rejected: 0,
      expired: 0,
      missing: 0,
      total: 0,
      label: "Incomplete",
    };

  const assignment =
    status?.assignment || {
      ready: false,
      label:
        "Not Assignment Ready",
    };

  return (
    <section className="profile-status-card">
      <div className="profile-status-header">
        <div>
          <p className="account-label">
            PROFILE STATUS
          </p>

          <h2>
            {profile.percentage}%
            Profile Complete
          </h2>

          <p className="profile-status-description">
            Complete your profile and
            verification requirements to
            become assignment-ready.
          </p>
        </div>

        <div
          className={`assignment-readiness-badge ${
            assignment.ready
              ? "ready"
              : "not-ready"
          }`}
        >
          <span>
            Assignment Status
          </span>

          <strong>
            {assignment.label}
          </strong>
        </div>
      </div>

      <div className="profile-status-grid">
        <article className="profile-status-section">
          <div className="profile-status-section-header">
            <div>
              <span>
                Profile Setup
              </span>

              <strong>
                {profile.completed} of{" "}
                {profile.total} sections
              </strong>
            </div>

            <strong className="profile-status-percentage">
              {profile.percentage}%
            </strong>
          </div>

          <div className="profile-status-progress">
            <div
              className="profile-status-progress-fill"
              style={{
                width:
                  `${profile.percentage}%`,
              }}
            />
          </div>

          <small>
            {profile.remaining === 0
              ? "All profile sections are complete."
              : `${profile.remaining} section${
                  profile.remaining !== 1
                    ? "s"
                    : ""
                } remaining.`}
          </small>
        </article>

        <article className="profile-status-section">
          <div className="profile-status-section-header">
            <div>
              <span>
                Credential Verification
              </span>

              <strong>
                {verification.verified} of{" "}
                {verification.total} verified
              </strong>
            </div>

            <span
              className={`profile-verification-label ${verification.label
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
            >
              {verification.label}
            </span>
          </div>

          <div className="profile-status-progress">
            <div
              className="profile-status-progress-fill verification"
              style={{
                width:
                  `${verification.percentage}%`,
              }}
            />
          </div>

          <div className="verification-counts">
            <span>
              {verification.verified} Verified
            </span>

            <span>
              {verification.pending} Pending
            </span>

            {verification.missing >
              0 && (
              <span>
                {verification.missing} Missing
              </span>
            )}

            {verification.rejected >
              0 && (
              <span>
                {verification.rejected} Rejected
              </span>
            )}

            {verification.expired >
              0 && (
              <span>
                {verification.expired} Expired
              </span>
            )}
          </div>
        </article>
      </div>
    </section>
  );
};

export default ProfileCompletionBar;